import { render, staticRenderFns } from "./InfosetListOverview.container.vue?vue&type=template&id=5a8c615a&"
import script from "./InfosetListOverview.container.vue?vue&type=script&lang=ts&"
export * from "./InfosetListOverview.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports